import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IDeleteAllVersionContentOnSiteParams {
  siteId: string;
}

export interface IDeleteAllVersionContentOnSiteResult extends IResult {
}

export class DeleteAllVersionContentOnSiteRequest
  extends Request<IDeleteAllVersionContentOnSiteParams, IDeleteAllVersionContentOnSiteResult> {

  constructor(params: IDeleteAllVersionContentOnSiteParams) {
    super('deleteAllVersionContentOnSite', params);
  }
}
